import { useState } from "react";
import { getAllModals } from "../services/dashboard";

export const useAllModels = () => {
  const [models, setModels] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchModels = async (manufacturerId: string) => {
    setLoading(true);
    try {
      const res = await getAllModals(manufacturerId);

      setModels(res.data.data || res.data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return { models, loading, fetchModels };
};
